__turbopack_context__.v({
  "animated": "Testimonial-module__1R33qG__animated",
  "author": "Testimonial-module__1R33qG__author",
  "authorInfo": "Testimonial-module__1R33qG__authorInfo",
  "authorPosition": "Testimonial-module__1R33qG__authorPosition",
  "comment": "Testimonial-module__1R33qG__comment",
  "darkMode": "Testimonial-module__1R33qG__darkMode",
  "header": "Testimonial-module__1R33qG__header",
  "index": "Testimonial-module__1R33qG__index",
  "kicker": "Testimonial-module__1R33qG__kicker",
  "main": "Testimonial-module__1R33qG__main",
  "quotes": "Testimonial-module__1R33qG__quotes",
  "reveal-up": "Testimonial-module__1R33qG__reveal-up",
  "rightSide": "Testimonial-module__1R33qG__rightSide",
  "swiperSlide": "Testimonial-module__1R33qG__swiperSlide",
  "testimonial": "Testimonial-module__1R33qG__testimonial",
  "testimonialContainer": "Testimonial-module__1R33qG__testimonialContainer",
  "title": "Testimonial-module__1R33qG__title",
});
